import { render, staticRenderFns } from "./FieldOrder.vue?vue&type=template&id=80c27912&scoped=true"
import script from "./FieldOrder.vue?vue&type=script&lang=js"
export * from "./FieldOrder.vue?vue&type=script&lang=js"
import style0 from "./FieldOrder.vue?vue&type=style&index=0&id=80c27912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c27912",
  null
  
)

export default component.exports